---
fr:
  notifications:
    admin:
      channels:
        email: E-mail
        portal_toast: Toast portail
      composer:
        fields:
          all_users: Tous les utilisateurs
          body: Corps du message
          channels: Canaux
          community_post: Lien vers un article communautaire
          context_url: URL de contexte (facultatif)
          direct_users: Destinataires directs
          features: Indicateurs de fonctionnalité
          portfolios: Portefeuilles
          scope: Portée
          send: Envoyer la notification
          severity: Gravité
          title: Titre
        hints:
          all_users_caption: À utiliser avec prudence pour les envois larges.
          all_users_tooltip: Envoie à tous les utilisateurs actifs du portail dans votre périmètre actuel.
          channels: Sélectionnez les canaux de diffusion et les segments avant l'envoi.
          context: Ajoutez un lien facultatif pour expliquer l'objectif de la notification.
          layout_intro: Rédigez d'abord le message, puis vérifiez les destinataires et les canaux avant d'envoyer.
          targeting: Combinez utilisateurs directs, portefeuilles et indicateurs de fonctionnalité pour contrôler les destinataires.
        preview:
          direct_users: Utilisateurs directs
          features: Indicateurs de fonctionnalité
          portfolios: Portefeuilles
        preview_headers:
          email: E-mail
          recipient: Destinataire
        recipient_notice:
          all_users: Envoi à tous les utilisateurs du portail.
          direct_summary: "{count} directs"
          feature_summary: "{count} via {feature}"
          loading: Calcul du nombre de destinataires...
          portfolio_summary: "{count} depuis {name}"
          select: Sélectionnez au moins un destinataire via des utilisateurs directs, des portefeuilles ou des indicateurs de fonctionnalité.
          separator: " • "
          summary: Envoi à {count} destinataires{details}
        sections:
          audience: Audience
          channels: Canaux et segments
          context: Contexte du message
          delivery: Livraison
          message: Contenu du message
          preview: Aperçu des destinataires
          review: Vérification et envoi
          settings: Paramètres de notification
          targeting: Ciblage direct
        send_summary:
          channels: 'Canaux : {value}'
          no_channels: Aucun canal sélectionné
          recipients: 'Destinataires : {count}'
          scope: 'Portée : {value}'
          scope_all_users: Tous les utilisateurs
          scope_selected: Destinataires sélectionnés
          severity: 'Gravité : {value}'
          title: Résumé d'envoi
        severities:
          error: Erreur
          info: Info
          success: Succès
          warning: Alerte
        title: Créer une notification
      delivery_status_reasons:
        email_channel_disabled: Canal e-mail désactivé
        invalid_email: Format d'e-mail invalide
        missing_recipient_email: Adresse du destinataire manquante
        missing_user_mapping: Aucune correspondance utilisateur
        portal_toast_channel_disabled: Toast portail désactivé
        portal_toast_opted_out: L'utilisateur a désactivé les popups in-app
        whitelist_block: Bloqué par la liste autorisée
      delivery_statuses:
        blocked_by_kill_switch: Bloqué par le coupe-circuit
        dropped_by_whitelist: Rejeté par la liste autorisée
        sent: Envoyé
        skipped_invalid_recipient: Ignoré (destinataire invalide)
        suppressed_by_user_preference: Supprimé par préférence utilisateur
      health:
        alert: Activité élevée détectée. Vérifiez les dernières livraisons et mettez un canal en pause si nécessaire.
        no_activity: Aucune activité récente
        per_channel_title: Livraisons sur les {minutes} dernières minutes
        range_15m: 15 dernières minutes
        range_1h: Dernière heure
        range_24h: 24 dernières heures
        range_7d: 7 derniers jours
        range_label: Fenêtre d’activité
        top_recipients_title: Principaux destinataires ({minutes} minutes)
      reports:
        channel_breakdown_title: Répartition par canal
        channel_series_label: Livraisons
        delivery_reason_empty: Aucune raison d'échec de livraison
        delivery_reason_title: Raisons des échecs de livraison
        delivery_status_all: Tous les statuts
        delivery_status_empty: Aucun statut de livraison
        delivery_status_label: Statut de livraison
        delivery_status_title: Statut de livraison
        errors:
          preview: Échec de l'aperçu des destinataires
          refresh: Échec de l'actualisation du rapport
          trigger: Échec du déclenchement de la notification
        failed_job_alerts_channel: 'Canal e-mail : {enabled}'
        failed_job_alerts_email_disabled: canal e-mail désactivé pour cet utilisateur
        failed_job_alerts_empty: Aucun destinataire opt-in pour le moment
        failed_job_alerts_title: Destinataires e-mail des échecs de tâches
        generated_at: Généré le {timestamp}
        headers:
          channels: Canaux
          delivery_status: Statut
          occurrences: Occurrences
          severity: Gravité
          title: Titre
          user: Utilisateur
          when: Date
        heading: Rapport des notifications du portail
        no_channel_data: Aucune donnée
        quick_tests: Notifications de test rapides
        read_label: Lues
        read_unread_series_label: Notifications
        read_unread_title: Lues vs non lues
        recent_notifications_title: Notifications récentes
        test_default_body: Généré depuis le rapport d'administration des notifications le %{timestamp}
        test_default_title: Test de notification %{severity}
        test_event_type_label: Type d'événement de test
        test_events:
          email: Test de livraison e-mail
          portal: Test de toast portail
        top_events_header_count: Nombre
        top_events_header_event: Événement
        top_events_title: Événements principaux
        top_recipients_header_count: Nombre
        top_recipients_header_user: Utilisateur
        top_recipients_title: Destinataires principaux
        totals_line: 'Actives : {active} • Non lues : {unread}'
        totals_title: Totaux
        trigger_label_prefix: Déclencher
        trigger_label_suffix: ''
        unknown_event: Inconnu
        unread_label: Non lues
      safeguards:
        confirm_disable: Désactiver les notifications {channel} ?
        disabled: Désactivé
        enabled: Activé
        never_disabled: Jamais désactivé
        recipient_hint: Les changements s’appliquent immédiatement aux nouveaux envois.
        recipient_prompt: Sélectionnez un utilisateur pour gérer ses canaux.
        recipient_search: Rechercher un destinataire
        recipient_subtitle: Suspendre des canaux pour un utilisateur lors d’une urgence.
        recipient_title: Overrides par destinataire
        recipient_unavailable: Les overrides administrateur ne sont pas disponibles dans cet environnement.
        refresh: Actualiser les sécurités
        subtitle: Les coupe-circuits permettent de mettre un canal en pause instantanément.
        title: Sécurités des canaux
      tabs:
        compose: Composer et envoyer
        reports: Rapports et tests
      tray:
        admin_link: Ouvrir le hub des notifications
        admin_link_hint: Gérez vos préférences et l'historique détaillé dans le hub.
        dismiss: Ignorer
        empty: Aucune notification pour le moment.
        mark_read: Marquer comme lue
        more_hint: "... +{count} de plus —"
        more_link: Voir dans le hub des notifications
        no_settings_user: Les paramètres de notification ne sont pas disponibles pour cette session.
        settings_link: Gérer les paramètres de notification
        similar: envois
        tabs:
          notifications: Notifications
          settings: Paramètres
        view: Voir
    email:
      generic:
        brand_heading: "%{brand}"
        button: Ouvrir le portail
        footer: Vous recevez cet e-mail car les notifications sont activées pour votre compte.
        meta:
          attempts: Tentatives
          failed_at: Échec le
          job_class: Classe de tâche
          job_id: ID de tâche
          queue: File d'attente
          run_at: Planifiée pour
          sent_at: Envoyé le
        sections:
          details: Détails de livraison
          error_excerpt: Erreur récente
          handler_excerpt: Charge utile de la tâche
        title: Vous avez une nouvelle notification
    hub:
      actions:
        dismiss_all: Tout effacer
        load_more: Charger plus
        mark_all_read: Tout marquer comme lu
        refresh: Actualiser le flux
      errors:
        notifications_fetch: Impossible de charger les notifications.
        notifications_update: Impossible de mettre à jour les notifications. Réessayez.
        preference_update: Impossible de mettre à jour les préférences. Réessayez.
      filters:
        range_30d: 30 derniers jours
        range_7d: 7 derniers jours
        range_all: Toute la période
        range_label: Période
        severity_all: Tout
        severity_attention: À surveiller
        severity_label: Afficher
        severity_success: Succès
        severity_updates: Mises à jour
        visibility_all: Tous les éléments
        visibility_label: Statut
        visibility_needs_action: À traiter
        visibility_open: Éléments ouverts
        visibility_unread: Non lues uniquement
      inbox:
        empty: Vous êtes à jour. Les nouvelles notifications s’afficheront ici.
        groups:
          today: Aujourd'hui
          undated: Sans horodatage
          yesterday: Hier
        hero_body: Consultez les dernières alertes, suivez les éléments en attente et ouvrez les détails en un seul endroit.
        hero_title: Gardez le contrôle
        meta:
          just_now: à l'instant
          last_refreshed: 'Dernière mise à jour: {value}'
          never_refreshed: Pas encore synchronisé
          range_label: Période
          total_label: Alertes totales
          unread_label: Non lues
        subtitle: Gérez vos alertes portail et gardez la cloche ordonnée.
        title: Mes notifications
      preferences:
        coming_soon: Bientôt disponible
        delivery_section_title: Canaux de diffusion
        email: Alertes e-mail
        email_hint: Envoyez une copie par e-mail pour garder une trace supplémentaire.
        failed_job_alerts: E-mails d'échec de tâche
        failed_job_alerts_hint: Admin et développeur uniquement. Activez pour recevoir les échecs de tâches en e-mail.
        notice: Les e-mails critiques du compte (ex. réinitialisation de mot de passe) sont toujours envoyés même si les alertes e-mail sont désactivées.
        sms: Alertes SMS
        sms_hint: Les alertes SMS arrivent bientôt.
        subtitle: Choisissez comment être informé. Certaines e-mails transactionnelles restent obligatoires.
        system_opt_ins_hint: Abonnements à des notifications opérationnelles qui ne sont pas des canaux de diffusion standards.
        system_opt_ins_title: Opt-ins système
        title: Canaux de diffusion
        toast: Alertes dans l'application
        toast_hint: Les alertes in-app contrôlent les popups en temps réel ; les éléments restent enregistrés dans la cloche et le hub.
      tabs:
        inbox: Mes notifications
    system:
      failed_job:
        body: Une tâche d'arrière-plan a échoué (tâche nº%{job_id}, %{attempts} tentatives).
        cta: Consulter la file des tâches
        preview: La tâche %{job_id} a échoué après %{attempts} tentatives.
        subject: La tâche de fond nº%{job_id} a échoué
        title: Échec d'une tâche d'arrière-plan
